import { phoneNumberRegexpCheck, scrollToAndFocusOnElement } from '../utils';

let shownAlert = false;

export default function checkoutPageFunctionality() {
  if (!document.body.classList.contains('woocommerce-checkout'))
    return;

  deliveryToDifferentAdressCheck();
  setDeliveryPlan();
}

function setDeliveryPlan() {
  setInterval(function () {
    let levplan = 'calculated-delivery-date';
    if (sessionStorage.getItem('levplan') == 'split-delivery')
      levplan = 'split-delivery';
    $('.delivery-plan').each(function () {
      $('.type', this).val(levplan);
      let holderVal = null;
      const sku = $(this).data('sku');

      switch (levplan) {
        case 'calculated-delivery-date':
          holderVal = sessionStorage.getItem('levplan_calculated[' + sku + ']');
          break;
        case 'later-delivery-date':
          holderVal = sessionStorage.getItem('levplan_later[' + sku + ']');
          break;
        case 'split-delivery':
          holderVal = sessionStorage.getItem('levplan_split[' + sku + ']');
          break;
        default:
      }

      $('.holder', this).val(holderVal);
    });

    deliveryDatesCheckout();
  }, 200);
}

function deliveryDatesCheckout() {
  if (!checkProductsDeliveryDates())
    checkoutDeliveryPlanError();
}

function checkoutDeliveryPlanError() {
  if (shownAlert)
    return;

  showDeliveryPlanErrorAlert();

  $('#place_order').attr('disabled', true);

  let reloadBtnText = 'Tillbaka till varukorgen';

  if (navigator.language !== 'sv-SE')
    reloadBtnText = 'Back to cart page';

  $('<a href="' + cartUrl + '" id="back-to-cart-btn" class="button">' + reloadBtnText + '</a>').insertBefore('#order_review');

  scrollToAndFocusOnElement('#back-to-cart-btn');
}

function checkProductsDeliveryDates() {
  let deliveryDetailsOnAllProducts = true;

  $('#order_review .cart_item .delivery-plan').each(function () {
    if ($('.type', this).val() === '' || $('.holder', this).val() === '')
      deliveryDetailsOnAllProducts = false;
  });

  return deliveryDetailsOnAllProducts;
}

function showDeliveryPlanErrorAlert() {
  if (shownAlert)
    return;

  shownAlert = true;

  let alertText = 'Något gick fel vid hämtning av leveransdatum, vänligen klicka på knappen med texten "Tillbaka till varukorgen" för att börja om orderprocessen';

  if (navigator.language !== 'sv-SE')
    alertText = 'Something went wrong while fetching delivery dates. Please click the button named "Back to cart page" and retry the order process';

  alert(alertText);
  $('#order_review').hide();
  $('#order_review_heading').hide();
}

function deliveryToDifferentAdressCheck() {
  if (!$('#ship-to-different-address-checkbox').length)
    return;

  $('.required').first().clone().appendTo('label[for="different_address_phone"]');

  $('#ship-to-different-address-checkbox').change(function () {
    if ($(this).is(':checked') && $('input[name="different_address_phone"]').val() == '') {
      $('button[name="woocommerce_checkout_place_order"]').attr('disabled', true);
    } else {
      $('button[name="woocommerce_checkout_place_order"]').attr('disabled', false);
    }
  });

  $('input[name="different_address_phone"]').on('input', function () {
    if (phoneNumberRegexpCheck($(this).val())) {
      $('button[name="woocommerce_checkout_place_order"]').attr('disabled', false);
    } else {
      $('button[name="woocommerce_checkout_place_order"]').attr('disabled', true);
    }
  });
}
